import ProfileManagement from "@/components/profile-management/profile-management";
import { z } from "zod";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/admin/_layout/profile-management")({
  validateSearch: z.object({ tab: z.string().min(1).catch("profile").default("profile") }),
  component: AdminProfileManagement,
});

function AdminProfileManagement() {
  const { tab } = Route.useSearch();
  return <ProfileManagement mode="admin" activeTab={tab} />;
}
